export class BrokerMapping {
    Active!:string;
    AffiliateFlag!:string;
    CustomerID!:string;
    FirmMPID!:string;
    ReceivedFromMPID!:string;
    id!:number;
    createdDate!:string;
    createdUser!:string;
    updatedDate!:string;
    updatedUser!:string;
}